import type { KrMarketStatus } from '../../services/crossMarketApi';
import './MarketScope.css';

interface Props {
  kr?: KrMarketStatus;
  title?: string;
}

export default function KrReplayPanel({ kr, title = 'KR Replay / Simulation' }: Props) {
  return (
    <section className="kr-replay-panel">
      <header>
        <div>
          <span className="market-kicker">Actual KR Data Only</span>
          <h3>{title}</h3>
        </div>
        <span className="live-chip">실주문 없음</span>
      </header>
      <div className="kr-replay-grid">
        <ReplayMetric label="Replay Run" value={kr ? `${kr.run_count}회` : '데이터 없음'} />
        <ReplayMetric label="판단" value={kr ? `${kr.decisions}건` : '데이터 없음'} />
        <ReplayMetric label="주문 의도" value={kr ? `${kr.orders}건` : '데이터 없음'} />
        <ReplayMetric label="모의 체결" value={kr ? `${kr.fills}건` : '데이터 없음'} />
      </div>
      <p>
        국내는 현재 Toss read-only와 replay/simulation 검증 단계입니다.
        국내 실계좌 잔고, 실제 보유 포지션, 실현 손익 데이터는 아직 운영 DB에 연결되지 않았습니다.
        현재 화면은 Toss read-only와 replay/simulation 검증 결과만 표시합니다.
      </p>
    </section>
  );
}

function ReplayMetric({ label, value }: { label: string; value: string }) {
  return (
    <span>
      <small>{label}</small>
      <strong>{value}</strong>
    </span>
  );
}
